<template>
    <div class="py-4 bg-secondary">
        <div class="profile-page">
            <section class="section-new">
                <div class="container">
                    <el-row>
                        <el-col :span="24">
                            <div class="card card-lift shadow border-0 card-address_page mb-3">
                                <el-breadcrumb separator-class="el-icon-arrow-right" class="vertical-center">
                                    <el-breadcrumb-item :to="{ path: '/' }">{{$t('menu.main')}}</el-breadcrumb-item>
                                    <el-breadcrumb-item>{{$t('menu.pro_active')}}</el-breadcrumb-item>
                                    <el-breadcrumb-item>{{$t('submenu.law_propagan')}}</el-breadcrumb-item>
                                </el-breadcrumb>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </section>
            <section class="section py-3">
                <div class="container">
                    <card shadow class="card-profile mt--100 card_radius_no" no-body>
                        <div class="px-4">
                            <div class="text-center mt-2">
                                <div class="h6 mt-4"><i class="ni business_briefcase-24 mr-2"></i><span
                                        class="news_title">{{$t('law_propagan.law_propagan_title')}}</span></div>
                            </div>
                            <div class="mt-1 py-5">
                                <div class="row">
                                    <div class="col-lg-12">
                                        <el-collapse v-model="activeName" accordion>
                                          <el-collapse-item :title="$t('law_propagan.law_propagan_yil9')" name="1"
                                                            class="text-center">
                                            <p style="text-align: justify;">
                                              {{$t('law_propagan.law_propagan_yil9_text')}}</p>
                                          </el-collapse-item>
                                          <el-collapse-item :title="$t('law_propagan.law_propagan_yil8')" name="2"
                                                            class="text-center">
                                            <p style="text-align: justify;">
                                              {{$t('law_propagan.law_propagan_yil8_text')}}</p>
                                          </el-collapse-item>
                                          <el-collapse-item :title="$t('law_propagan.law_propagan_yil7')" name="3"
                                                            class="text-center">
                                            <p style="text-align: justify;">
                                              {{$t('law_propagan.law_propagan_yil7_text')}}</p>
                                          </el-collapse-item>
                                          <el-collapse-item :title="$t('law_propagan.law_propagan_yil6')" name="4"
                                                            class="text-center">
                                            <p style="text-align: justify;">
                                              {{$t('law_propagan.law_propagan_yil6_text')}}</p>
                                          </el-collapse-item>
                                        </el-collapse>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </card>
                </div>
            </section>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                activeName: '1'
            };
        }
    }
</script>
<style>
</style>
